var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_vm._t("default",function(){return [_c('div',[_vm._v("\n      暂无内容\n    ")])]}),_c('hideBox',{attrs:{"item":_vm.item,"type":_vm.type}}),(_vm.isLaborCompany)?_c('hideBoxs',{attrs:{"item":_vm.item,"type":_vm.type}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }